import Typography from '@mui/material/Typography';

import { CustomFieldProps } from '../../../../../interfaces/CustomFieldProps';

const TitleField = ({ field }: CustomFieldProps) => (
  <Typography marginBottom='16px' fontWeight={500} fontSize={20}>
    {field.fieldTitle}
  </Typography>
);

export default TitleField;
